/** Clipboard and retry rules shared by response-card renderers and tests. */

/**
 * Mirrors iPhone's ArtifactParser.stripTags: remove artifact wrappers while
 * retaining their generated content for a useful pasted response.
 */
export function stripArtifactTags(text: string): string {
  let result = text;
  const openTag = "<antArtifact";
  const closeTag = "</antArtifact>";

  let openIndex = result.indexOf(openTag);
  while (openIndex !== -1) {
    const closeAngleIndex = result.indexOf(">", openIndex);
    if (closeAngleIndex === -1) break;
    result = result.slice(0, openIndex) + result.slice(closeAngleIndex + 1);
    openIndex = result.indexOf(openTag);
  }

  return result.replaceAll(closeTag, "").trim();
}

/** Builds the same contextual clipboard format as the iPhone response card. */
export function buildResponseCardCopyText({
  providerName,
  metaLine1,
  metaLine2,
  text,
}: {
  providerName: string;
  metaLine1?: string;
  metaLine2?: string;
  text: string;
}): string {
  const lines = [providerName];
  if (metaLine1) lines.push(metaLine1);
  if (metaLine2) lines.push(metaLine2);

  const body = stripArtifactTags(text);
  if (body) lines.push("", body);
  return lines.join("\n");
}

/** Mirrors CompactChatView.shouldShowRetry on iPhone. */
export function shouldShowResponseRetry({
  hasRetryHandler,
  wasInterrupted,
  hasError,
  isComplete,
}: {
  hasRetryHandler: boolean;
  wasInterrupted: boolean;
  hasError: boolean;
  isComplete: boolean;
}): boolean {
  return hasRetryHandler && (wasInterrupted || (hasError && isComplete));
}
